
import CompanyShare from '../../pages/companyshare/CompanyShare';

import Logout from '../../pages/Logout/Logout';


const CompanyShares = [
    { path: "/", name: "KIIT_University", element: CompanyShare, exact: true },
    { path: "/logout", name: "KIIT_University", element: Logout, exact: true },
]

export default CompanyShares;